import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { GradientSpinner } from '@/core/components/Loading';
import { useAuth } from '@/core/hooks/useAuth';

const RETURN_URL_KEY = 'login_return_url';

export function AuthCallbackPage() {
  const { user, loading: authLoading, signInWithGoogleCode, signInWithAppleCode } = useAuth();
  const [error, setError] = useState(null);
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    if (processing) return;

    const params = new URLSearchParams(window.location.search);
    const googleCode = params.get('code');
    const appleCode = params.get('apple_code');

    if (appleCode) {
      const state = params.get('state');
      const savedState = sessionStorage.getItem('apple_auth_state');
      const clientId = sessionStorage.getItem('apple_client_id');

      if (state && savedState && state !== savedState) {
        setError('認証に失敗しました（state mismatch）');
        return;
      }

      if (clientId) {
        setProcessing(true);
        sessionStorage.removeItem('apple_auth_state');
        sessionStorage.removeItem('apple_client_id');

        signInWithAppleCode(appleCode, clientId).catch((err) => {
          console.error('Apple login error:', err);
          setError('Appleログインに失敗しました');
        });
      }
      return;
    }

    if (googleCode) {
      setProcessing(true);
      signInWithGoogleCode(googleCode).catch((err) => {
        console.error('Google login error:', err);
        setError('Googleログインに失敗しました');
      });
    }
  }, [signInWithGoogleCode, signInWithAppleCode, processing]);

  if (!authLoading && user) {
    const savedReturnUrl = sessionStorage.getItem(RETURN_URL_KEY);
    sessionStorage.removeItem(RETURN_URL_KEY);
    return <Navigate to={savedReturnUrl || '/dashboard'} replace />;
  }

  if (error) {
    return <Navigate to={`/login?error=${encodeURIComponent(error)}`} replace />;
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
        <GradientSpinner />
        <Typography variant="body1" sx={{ color: 'text.secondary', fontWeight: 500 }}>
          ログイン処理中...
        </Typography>
      </Box>
    </Box>
  );
}
